module.exports = __webpack_public_path__ + "static/nhan_quan_11-9cf12e48020200715988fd61ddc4f43b.jpg";